import { create } from 'zustand';

import { createDoBoxRunViewSlice } from './actions';
import { DoBoxRunViewStore } from './types';
import type { PresentedStatusOverride } from '../../utils/delegation/resolvePresentedRunStatus';

export const useDoBoxRunViewStore = create<DoBoxRunViewStore>()(
  (set, get, store) => ({
    ...createDoBoxRunViewSlice(set, get, store),
  }),
);

export const useIsRunViewOpen = (entryId: string): boolean =>
  useDoBoxRunViewStore((state) => entryId in state.openByEntryId);

export const useIsRunViewFullScreen = (entryId: string): boolean =>
  useDoBoxRunViewStore(
    (state) => state.openByEntryId[entryId]?.fullScreen ?? false,
  );

export const useRunViewRunId = (entryId: string): string | undefined =>
  useDoBoxRunViewStore((state) => state.openByEntryId[entryId]?.runId);

export const usePresentedStatusOverride = (
  entryId: string,
): PresentedStatusOverride | undefined =>
  useDoBoxRunViewStore((state) => state.presentedStatusByEntryId[entryId]);
